module.exports = __webpack_public_path__ + "img/6.c0a4de6e.png";